import {getters} from './getters'
import {actions} from './actions'
import {mutations} from './mutations'

export const state = {

  /** Jira projects **/
  jiraProjects: [],
  searchEmployeesResults: [],
  searchIssuesResults: [],

  /** Other **/
  departments: [],
}

const namespaced = false

export const jira = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
